
import { Component, Prop } from 'vue-property-decorator';
import { schemeNodeModelToTreeNode } from '@/services/scheme';
import { SchemeScope } from '@/components/mixins/schemescope';
import { mixins } from 'vue-class-component';

@Component
export default class InsertLink extends mixins(SchemeScope) {
  @Prop() private value!: boolean;
  @Prop() private skillOnly!: boolean;

  private search = '';
  private showSkillWarning = false;

  get items() {
    return schemeNodeModelToTreeNode(this.getNode('/'));
  }

  selectNode(nodes: Array<string>) {
    const schemeNodeId = nodes.length > 0 ? nodes[nodes.length - 1] : '/';
    if (schemeNodeId === '/') {
      return;
    }
    if (!this.skillOnly) {
      this.$emit('selected', schemeNodeId);
    } else {
      const node = this.getNode(schemeNodeId);
      if (node && node.grade) {
        this.showSkillWarning = false;
        this.$emit('selected', schemeNodeId);
      } else {
        this.showSkillWarning = true;
      }
    }
  }

  handleSearch() {
    const tree = this.$refs.schemeTree as any;
    tree.updateAll(true);
  }

  async close() {
    this.showSkillWarning = false;
    this.$emit('input', false);
  }
}
